import { useEffect } from 'react';

function useOnMount(fn) {
  useEffect(fn, []);
}

export default useOnMount;
